export default {
    BaseSaveToWorkspace: {
        Main: {
            cancel: 'キャンセル',
            submit: '確認',
            saveToWorkspaceLink: '追加しています。後でワークスペースの「{link}」フォルダをチェックしてください',
            title: 'ワークスペースに追加',
        },
        FolderSelector: {
            label: 'フォルダー選択',
            addWorkspace: 'ワークスペースを追加',
            searchType: {
                workspace: 'ワークスペース',
                folder: 'フォルダ',
            },
            placeholder: '名前を入力してください',
            noData: {
                workspace: 'まだ作業スペースはありません',
                folder: 'まだフォルダはありません',
                searchFolder: '対応するフォルダが見つかりません',
                searchSpace: '作業スペースがまだ存在しません',
            },
            newFolderName: '新しいフォルダを作成する',
            newWorkspaceName: '新規ワークスペース',
            workspaceGroupType: {
                public: '企業ワークスペース',
                shared: '共有のワークスペースから',
                self: '個人ワークスペース',
            },
            lastFlag: {
                ADD: '最近の保存',
                COPY: '最近のコピー',
                MOVE: '最近の移動',
                RELATED: 'プロジェクト関連',
            },
        },
        RangeSelector: {
            from: 'から',
            to: 'まで',
            title: '範囲を選択',
            selectAllLabel: 'すべてを選択',
            family: {
                label: '全ての特許及びそのファミリーを保存',
                types: {
                    SIMPLE: '全ての特許とシンプルファミリー',
                    INPADOC: '全ての特許とINPADOCファミリー',
                    EXTEND: '全ての特許とPatSnapファミリー',
                    APNO: 'すべての特許及び同出願番号の特許',
                },
                error: 'ファミリーのデータが異常です。キャンセルして再試行してください。',
            },
            tip: '検索結果をパケット表示に設定すると、範囲選択された特許は代表特許。',
            selectAllFamilyLabel: '{allCounts} ファミリー',
            selectAllFamilyPatentCountLabel: '<span style="color: #8993A4">({count} 件のレコード)をすべて選択します</span>',
            familyLabel: '({count} 件のレコード)',
            selectFamilyLabel: '{allCounts} 家族 <span style="color: #8993A4">({count} 件のレコード)が選択されました</span>',
        },
        AutoUpdate: {
            otherSettingLabel: '他の設定',
            label: '新特許の場合、自動的にこのフォルダに更新されます',
            viewQuery: '検索クエリを確認',
            tip: 'フォルダの自動収録が開いていれば、さらに別の検索クエリにより自動収録することはできません。全特許選択時(同族特許同時保存なし)のみ、自働収録をオンにすることができる。',
            refine: 'フィルタ',
            familylabel: '新しいファミリーがヒットすると、自動的に該フォルダへ更新します',
            familyTip: 'フォルダに対して「検索式により自動更新」が実行中になっている場合、この設定は有効になりません',
        },
        PAPER: {
            RangeSelector: {
                simpleSelectLabel: '<span class="s2w-simple-count">{count}</span> 件の文献が選択されました',
                error: {
                    invalidError: '適切な範囲内でデータを入力してください',
                    overMaxCountError: '入力した範囲の数値が{limit}を超えないようにしてください',
                    rangeError: '一度に最大{limit}件の記録を保存できます',
                },
            },
        },
        PATENT: {
            RangeSelector: {
                simpleSelectLabel: '<span class="s2w-simple-count">{count}</span> 件の特許が選択されました',
                error: {
                    invalidError: '@:BaseSaveToWorkspace.PAPER.RangeSelector.error.invalidError',
                    overMaxCountError: '@:BaseSaveToWorkspace.PAPER.RangeSelector.error.overMaxCountError',
                    rangeError: '@:BaseSaveToWorkspace.PAPER.RangeSelector.error.rangeError',
                    disabledSelectAllError: 'フォルダ内に保存可能な上限({limit})を超えました',
                    familyRangeError: '保存毎に最大{limit}族',
                },
            },
        },
        VC: {
            RangeSelector: {
                simpleSelectLabel: '<span class="s2w-simple-count">{count}</span> 件を選択しました',
                error: {
                    invalidError: '@:BaseSaveToWorkspace.PAPER.RangeSelector.error.invalidError',
                    overMaxCountError: '@:BaseSaveToWorkspace.PAPER.RangeSelector.error.overMaxCountError',
                    rangeError: '一回で最大{limit}件のVCを保存できます。',
                },
            },
        },
        MA: {
            RangeSelector: {
                simpleSelectLabel: '<span class="s2w-simple-count">{count}</span> 件の企業合併を選択しました。',
                error: {
                    invalidError: '@:BaseSaveToWorkspace.PAPER.RangeSelector.error.invalidError',
                    overMaxCountError: '@:BaseSaveToWorkspace.PAPER.RangeSelector.error.overMaxCountError',
                    rangeError: '一回で最大{limit}件の合併を保存できます。',
                },
            },
        },
        MR: {
            RangeSelector: {
                simpleSelectLabel: '<span class="s2w-simple-count">{count}</span> 件の市場レポートを選択しました',
                error: {
                    invalidError: '@:BaseSaveToWorkspace.PAPER.RangeSelector.error.invalidError',
                    overMaxCountError: '@:BaseSaveToWorkspace.PAPER.RangeSelector.error.overMaxCountError',
                    rangeError: '一回で最大{limit}件の市場レポートを保存できます。',
                },
            },
        },
        sequence: {
            selected: '選択済み',
            sequences: 'シーケンス',
        },
    },
};
